var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.49902L0.602885 0.499024L8.39711 0.499024L4.5 6.49902Z",
    fill: "#F8F8FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentDrop);
export default __webpack_public_path__ + "static/media/contentDrop.96af3a8ea7c8aac540bae14555fb2cc3.svg";
export { ForwardRef as ReactComponent };